import { useEffect, useState } from 'react';
import { getIdleSessionPolicy } from 'shared/utils/idleSessionConfig';
import {
  formatIdleRemaining,
  getIdleRemainingMs,
  subscribeIdleRemaining,
} from 'shared/utils/idleSessionManager';

export default function useIdleSessionRemaining() {
  const [remainingMs, setRemainingMs] = useState(() => getIdleRemainingMs());
  const [idleTimeoutMs, setIdleTimeoutMs] = useState(
    () => getIdleSessionPolicy().idleTimeoutMs
  );

  useEffect(
    () =>
      subscribeIdleRemaining((ms) => {
        setRemainingMs(ms);
        setIdleTimeoutMs(getIdleSessionPolicy().idleTimeoutMs);
      }),
    []
  );

  return {
    remainingMs,
    idleTimeoutMs,
    formatted: formatIdleRemaining(remainingMs),
    timeoutLabel: formatIdleRemaining(idleTimeoutMs),
  };
}
